import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { InfoIcon } from "assets";
import { COLORS } from "../consts";

import {
  CHIP_TOOLTIP_STYLES,
  FALLBACK,
  FORMULA_TOOLTIP_STYLES,
  INFO_ICON_STYLES,
  TOOLTIP_STYLES,
  TOOLTIP_TEXT_STYLES,
  TOOLTIP_TITLE_STYLES,
} from "../metric-card/styles";
import { InfoTooltipProps } from "./types";

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  tooltip,
  colors = FALLBACK,
  iconColor,
  size,
}) => {
  const ic = iconColor ?? COLORS.Romance;

  let content: React.ReactNode;
  if (typeof tooltip === "string") {
    content = tooltip;
  } else {
    const chipLabel =
      tooltip.chip ?? (tooltip.formula ? "Calculated" : undefined);
    content = (
      <Box>
        {tooltip.title && (
          <Typography sx={TOOLTIP_TITLE_STYLES}>{tooltip.title}</Typography>
        )}
        <Typography sx={TOOLTIP_TEXT_STYLES}>{tooltip.text}</Typography>
        {(tooltip.formula || chipLabel) && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
            {tooltip.formula &&
              (Array.isArray(tooltip.formula) ? (
                tooltip.formula.map((f) => (
                  <Box key={f} sx={FORMULA_TOOLTIP_STYLES(colors)}>
                    {f}
                  </Box>
                ))
              ) : (
                <Box sx={FORMULA_TOOLTIP_STYLES(colors)}>{tooltip.formula}</Box>
              ))}
            {chipLabel && (
              <Box sx={CHIP_TOOLTIP_STYLES(colors)}>{chipLabel}</Box>
            )}
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Tooltip title={content} slotProps={{ tooltip: { sx: TOOLTIP_STYLES } }}>
      <Box
        component="span"
        sx={size ? { ...INFO_ICON_STYLES, width: size, height: size } : INFO_ICON_STYLES}
      >
        <InfoIcon color={ic} {...(size ? { width: size, height: size } : {})} />
      </Box>
    </Tooltip>
  );
};
